export const GET_INSTALLMENTS = 'GET_INSTALLMENTS';
export const GET_INSTALLMENTS_ERROR = 'GET_INSTALLMENTS_ERROR';
export const GET_INSTALLMENTS_REQUEST = 'GET_INSTALLMENTS_REQUEST';
export const GET_INSTALLMENTS_SUCCESS = 'GET_INSTALLMENTS_SUCCESS';

export const SET_INSTALLMENTS = 'SET_INSTALLMENTS';
